import { ThemeSwitcher } from '@components/ThemeSwitcher/ThemeSwitcher'
import Colors from '@constants/Colors'
import { Box, Button, Stack, styled, Typography, useTheme } from '@mui/material'
import React from 'react';

type Props = {
  onBack?: () => void;
  title?: string;
  backText?: string;
  info?: React.ReactNode;
  buttons?: React.ReactNode;
}

const ProfileFloatingBarStyled = styled(Stack)(({ theme }) => ({
  borderRadius: "16px",
  border: "1px solid rgba(255, 255, 255, 0.20)",
  background: theme.palette.mode === 'light' ? "var(--Neutral-Light-Gray, #f9f9f9)" : "var(--Dasbhoard, #222426)",
  boxShadow: "0px 3px 12px 0px rgba(0, 0, 0, 0.08)",

}));

const BoxStyled = styled(Box)(({ theme }) => ({
  position: 'fixed',
  zIndex: 1000,
  top: 30,
  left: 0,
  display: 'flex',
  width: '100%',
  padding: '0 32px',
}))


const FloatingBar = (props: Props) => {
  const theme = useTheme();
  return (
    <BoxStyled>
      <ProfileFloatingBarStyled flexDirection={'row'} justifyContent="space-between" alignItems="center" sx={{ padding: 2, width: '100%' }}>
        <Stack flexDirection={"row"} alignItems="center" gap={1}>
          <Button
            startIcon={<i className="fi-br-arrow-small-left" style={{ color: theme.palette.mode === 'light' ? Colors.FLOATING_BAR_TEXT : Colors.NEUTRAL_WHITE }} />}
            variant="text"
            color="neutralWhite"
            sx={{ fontSize: 20, fontWeight: 600, }}
            onClick={() => props.onBack ? props.onBack() : window.history.back()}>
            {props.backText || 'Retour'}
          </Button>
          {props.info && <Box>|</Box>}
          {props.info}
        </Stack>
        {props.title && <Typography variant="h5" sx={{ fontWeight: 700, textAlign: 'center', flexGrow: 1 }}>
          {props.title}
        </Typography>}
        <Box display={'flex'} flexDirection={'row'} gap={2}>
          <ThemeSwitcher open />
          <Stack flexDirection={"row"} alignItems="center" gap={2}>
            {props.buttons}
          </Stack>
        </Box>
      </ProfileFloatingBarStyled>
    </BoxStyled>
  )
}

export default FloatingBar
